module.exports = __webpack_public_path__ + "static/media/img-topics-sample10.21264950.jpg";